const HOUR_IN_MINUTES = 60;

function timeToMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * HOUR_IN_MINUTES + minutes;
}

function calculateMinutes(startTime, endTime) {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);

    const startMinutes = startHour * 60 + startMinute;
    const endMinutes = endHour * 60 + endMinute;

    let timeDifference = endMinutes - startMinutes;
    if (timeDifference < 0) {
        timeDifference = 24 * 60 - startMinutes;
    }

    return timeDifference;
}

function checkCompletedPeriods(events, days) {
    const minute = 1;
    const DAY_IN_MINUTES = 1440 - minute;
    const dayMap = {};

    for (let event of events) {
        const day = event.day;
        let duration = 0;

        if (event.shift?.startTime && event.shift?.endTime) {
            const startDate = new Date(event.shift.startTime);
            const endDate = new Date(event.shift.endTime);
            duration = Math.floor((endDate - startDate) / (1000 * 60));
        } else {
            duration = calculateMinutes(event.startTime, event.endTime || "23:59");
        }

        if (!dayMap[day]) {
            dayMap[day] = 0;
        }

        dayMap[day] += duration;
    }

    for (let d = 1; d <= days; d++) {
        if (dayMap[d] !== DAY_IN_MINUTES) {
            return false;
        }
    }

    return true;
}

function verifyIfHasPermission(vm) {
    const routeName = vm.$route.name;
    const permissions = vm.$store.state.calendar.permissions;

    if (routeName === "newCalendar" && !permissions.find((e) => e.type === "create")) {
        vm.$store.commit("calendar/UPDATE_BYPASS_LEAVE", true);
        vm.$router.push({ name: "standard" });
        return;
    }

    if (routeName === "editCalendar" && !permissions.find((e) => e.type === "update")) {
        vm.$store.commit("calendar/UPDATE_BYPASS_LEAVE", true);
        vm.$router.push({ name: "standard" });
        return;
    }
}

export { timeToMinutes, checkCompletedPeriods, calculateMinutes, verifyIfHasPermission };
